<script>
import ModalCloseButton from '@phoenix/mixins/components/common/ModalCloseButton';

export default {
  mixins: [ModalCloseButton],

  props: {
    isSgphx: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return {
        'sgphx-btn sgphx-btn--fade sgphx-btn--icon-only sgphx-btn--icon sgphx-modal__close-button': this.isSgphx,
        'button button--icon button--close button--light': !this.isSgphx,
      };
    },
  },
};
</script>

<template>
  <button
    :class="classes"
    :aria-label="$t('Modal.closeDialog')"
    data-cy="modal-close-button"
    @click="closeModal(modalId)"
  >
    <slot />
  </button>
</template>
